var map = {
	"./about-us.svg": "35cd",
	"./add-round.svg": "927e",
	"./add.svg": "bf43",
	"./alert-round.svg": "a86c",
	"./alert-triangle.svg": "56e0",
	"./arrow-down.svg": "0776",
	"./arrow-right.svg": "28e1",
	"./back.svg": "9a1b",
	"./blog.svg": "1cf9",
	"./calendar.svg": "818a",
	"./challenges.svg": "9e31",
	"./chevron-right.svg": "3a42",
	"./clock.svg": "e300",
	"./copy.svg": "c474",
	"./crossplay.svg": "364c",
	"./daily.svg": "7d17",
	"./danger.svg": "56a6",
	"./decrement-arrow.svg": "958c",
	"./document-check.svg": "b1fa",
	"./edit.svg": "4071",
	"./ellipse-filled.svg": "b2fc",
	"./ellipse.svg": "8578",
	"./email.svg": "a605",
	"./expand-down.svg": "032b",
	"./eye-off.svg": "7615",
	"./eye.svg": "59b3",
	"./filter-active.svg": "f098",
	"./fire.svg": "5d96",
	"./freematch.svg": "1d0d",
	"./games.svg": "7a50",
	"./google.svg": "ed02",
	"./help.svg": "ae9d",
	"./home.svg": "43e3",
	"./hour.svg": "72cd",
	"./identity-reverse.svg": "09e3",
	"./identity.svg": "5b27",
	"./increment-arrow.svg": "34dd",
	"./info.svg": "cd69",
	"./instagram.svg": "6bcf",
	"./language.svg": "13cf",
	"./loader.svg": "6234",
	"./loading.svg": "d3da",
	"./lock.svg": "07bf",
	"./logo-icon.svg": "5d20",
	"./map-pin.svg": "ede6",
	"./matches-highlighted.svg": "c940",
	"./matches.svg": "67b7",
	"./menu.svg": "3c9e",
	"./message.svg": "743b",
	"./minigames.svg": "cd2b",
	"./mobile.svg": "2bbe",
	"./more-vertical.svg": "49e3",
	"./new.svg": "ed81",
	"./no-stars.svg": "9f51",
	"./notification.svg": "a73f",
	"./padlock.svg": "4726",
	"./paperclip.svg": "02f9",
	"./pc.svg": "68ed",
	"./phone.svg": "6af8",
	"./plus-circle.svg": "0073",
	"./plus.svg": "cf6d",
	"./position.svg": "e720",
	"./prizes.svg": "eaa0",
	"./pro.svg": "833d",
	"./ps4-xboxone.svg": "3127",
	"./ps4.svg": "735c",
	"./ps5-xboxxs.svg": "d04b",
	"./ps5.svg": "cbfc",
	"./referee.svg": "f296",
	"./screenshot.svg": "39ad8",
	"./search.svg": "751f",
	"./send.svg": "ba6e",
	"./share.svg": "3f84",
	"./smile.svg": "773b",
	"./spinner.svg": "e7cd",
	"./star-filled.svg": "5bf4",
	"./star.svg": "fae0",
	"./success.svg": "5cd2",
	"./textarea.svg": "ec35",
	"./timer.svg": "ea4b",
	"./transger.svg": "e8f4",
	"./twitch.svg": "8134",
	"./twitter.svg": "51e3",
	"./upload-success.svg": "99e2",
	"./upload.svg": "58b6",
	"./user-add.svg": "65e5",
	"./user.svg": "ac03",
	"./verified.svg": "2150",
	"./wallet.svg": "be27",
	"./weekly.svg": "17b5",
	"./whatsapp.svg": "88f9",
	"./x.svg": "5c38",
	"./xbox-one.svg": "87f8",
	"./xbox-xs.svg": "66ab",
	"./youtube.svg": "3d4e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "44f3";